import React from "react"
import { getName } from "utils/custom.utils"
import { inr } from "utils/formatters.utils"
import { DELIVERY_METHODS, PAYMENT_METHODS } from "data/static.items"
const HR = () => {
  return <hr className="mt-0 mb-2" />
}
const OrderInfo = ({ order }) => {
  const user = order?.user
  const pay = getName(order?.paymentMethod, PAYMENT_METHODS)
  const ship = getName(order?.shippingMethod, DELIVERY_METHODS)
  const out = order?.totalAmount - order?.totalPaid

  return (
    <>
      <div className="grid grid-cols-12 gap-4">
        <div className="col-span-6">
          <h6>Order</h6>
          <HR />
          <div>
            {" "}
            Placed On - <span className="font-bold">{order?.date}</span>
          </div>
          <div className="mt-2">
            {" "}
            Payment Method - <span className="font-bold">{pay}</span>
          </div>
          <div className="mt-2">
            {" "}
            Shipping Method - <span className="font-bold">{ship}</span>
          </div>

          <div className="mt-2">
            {" "}
            Total Outstanding - <span className="font-bold">{inr(out)}</span>
          </div>
          {order?.crateCount > 0 && (
            <div className="mt-2">
              {" "}
              Total Crates -{" "}
              <span className="font-bold">{order.crateCount}</span>
            </div>
          )}
        </div>
        <div className="col-span-6">
          <h6>User</h6>
          <HR />
          <div className="font-bold">{user?.fullName}</div>
          <div className="text-sm vt-muted">{user?.number}</div>
        </div>
      </div>
      <div className="grid grid-cols-12 gap-4 mt-5">
        <div className="col-span-6">
          <h6>Point Of Contact (POC)</h6>
          <HR />
          <div className="font-bold">{order?.pocName}</div>
          <div className="text-sm vt-muted">{order?.pocNumber}</div>
        </div>
        <div className="col-span-6">
          <h6>Shipping Address</h6>
          <HR />
          <div className="font-bold">{order?.shippingAddress?.village}</div>
          <div className="text-sm vt-muted">
            {order?.shippingAddress?.address}
          </div>
        </div>
      </div>
    </>
  )
}

export default OrderInfo
